import styled from 'styled-components'

const SplitLine = styled.div`
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  max-width: 1200px;
  margin-top: 10px;
  margin-bottom: 40px;
`

export default SplitLine
